import { DestinationEvent } from '@eventbrite/consumer-search.event-renderer';

type FilterUnactionableEventsOptions = {
    // Members can act on not-yet-on-sale events that carry early access tickets.
    includeNotYetOnSaleEarlyAccess?: boolean;
};

export const filterUnactionableEvents = (
    events?: DestinationEvent[],
    { includeNotYetOnSaleEarlyAccess = false }: FilterUnactionableEventsOptions = {},
) => {
    if (!events || !events.length) {
        return [];
    }

    return events.filter((event) => {
        const salesStatus = event.event_sales_status?.sales_status;
        const isOnSale = salesStatus === 'on_sale';
        const isRecurrent = !!event.num_children && event.num_children > 1;
        const isEarlyAccessPreSale =
            includeNotYetOnSaleEarlyAccess &&
            salesStatus === 'not_yet_on_sale' &&
            event.ticket_availability?.has_early_access_tickets === true;

        return isOnSale || isRecurrent || isEarlyAccessPreSale;
    });
};
